import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Path } from 'config/portal'
import { formatUrl } from 'utils'
import { selectors } from '../reducer'

const propTypes = {
  data: PropTypes.shape({
    serviceAgreementId: PropTypes.string.isRequired,
    completeLegalPlanName: PropTypes.string.isRequired,
  }).isRequired,
  bdPlanAgreements: PropTypes.arrayOf(Types.bdPlanAgreementsSummary).isRequired,
  setBdPlanAgreementDetails: PropTypes.func.isRequired,
  setBDPlanAgreementDetailsId: PropTypes.func.isRequired,
}

const PlanAgreementDetailsLinkBD = ({
  data: { serviceAgreementId, completeLegalPlanName },
  bdPlanAgreements,
  setBdPlanAgreementDetails,
  setBDPlanAgreementDetailsId,
}) => {
  const bdPlanDetails = bdPlanAgreements.find(
    (bdPlanAgreement) =>
      bdPlanAgreement.serviceAgreementId === serviceAgreementId
  )

  return (
    <td>
      <Link
        to={(location) => {
          return {
            pathname: formatUrl(
              `${Path.BD_SERVICES_AGREEMENTS}/${serviceAgreementId}`
            ),
            state: { search: location.search },
          }
        }}
        className="link-text"
        id="plan-name-link"
        onClick={() => {
          setBdPlanAgreementDetails(bdPlanDetails)
          setBDPlanAgreementDetailsId(serviceAgreementId)
        }}
      >
        {completeLegalPlanName}
      </Link>
    </td>
  )
}

function mapStateToProps(state) {
  return {
    bdPlanAgreements: selectors.bdPlanAgreements(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBdPlanAgreementDetails: (bdPlanAgreement) => {
      dispatch({
        type: 'SET_BD_PLAN_AGREEMENT_DETAILS',
        payload: bdPlanAgreement,
      })
    },
    setBDPlanAgreementDetailsId: (serviceAgreementId) => {
      dispatch({
        type: 'SET_BD_PLAN_AGREEMENT_DETAILS_ID',
        payload: serviceAgreementId,
      })
    },
  }
}
PlanAgreementDetailsLinkBD.propTypes = propTypes

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  PlanAgreementDetailsLinkBD
)
